import type React from 'react';
import Link from 'next/link';
import ReviewsV2Word from './ReviewsV2Word';

export default function Footer() {
  return (
    <footer style={{ background: 'var(--sk-band, linear-gradient(160deg, #0d47a1 0%, #1565c0 50%, #0a3d8f 100%))' }}>
      <div className="max-w-4xl mx-auto px-6 pt-12 pb-8">

        {/* Brand — centered, like the header */}
        <div className="text-center mb-8">
          <picture>
            <source srcSet="/brand/logo-white.avif" type="image/avif" />
            <source srcSet="/brand/logo-white.webp" type="image/webp" />
            <img
              src="/brand/logo-white.webp"
              alt="המומחים"
              width={227}
              height={38}
              className="h-[45px] w-auto mx-auto"
              style={{ objectFit: 'contain' }}
              loading="lazy"
            />
          </picture>
          <p className="text-sm font-semibold text-white mt-2">לקבל בחינם הצעות ממומחים מומלצים לידך</p>
        </div>

        {/* למה אנחנו — centered list, no heading */}
        <ul className="text-center space-y-3 max-w-xs mx-auto mb-10">
          {/* "ביקורות" → "המלצות" on a reviews-v2 preview pro page (components/ReviewsV2Word.tsx) */}
          {([
            ['objective', <>⭐️ <ReviewsV2Word /> אובייקטיביות בלבד</>],
            ['verified', <>✅ <ReviewsV2Word /> מאומתות בלבד</>],
            ['free', '🎁 זה בחינם'],
            ['fast', '🚀 תגובה מהירה'],
            ['love', '❤️ נעשה באהבה :)'],
          ] as [string, React.ReactNode][]).map(([k, t]) => (
            <li key={k} className="text-sm font-semibold text-white">{t}</li>
          ))}
        </ul>

        {/* Bottom bar — site links + copyright */}
        <div className="border-t pt-6 text-center" style={{ borderColor: 'rgba(255,255,255,.12)' }}>
          <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 mb-4">
            {[
              ['אודות', '/אודות'],
              ['מאמרים', '/מאמרים'],
              ['צור קשר', '/צור-קשר'],
              ['פרטיות', '/פרטיות'],
              ['תנאי משתמש', '/תנאים'],
            ].map(([n, h]) => (
              <Link key={n} href={h} className="text-sm transition-all hover:text-white"
                style={{ color: 'rgba(255,255,255,.78)', fontWeight: 300 }}>
                {n}
              </Link>
            ))}
          </div>
          <p className="text-sm" style={{ color: 'rgba(255,255,255,.55)', fontWeight: 300 }}>
            © 2026 המומחים · כל הזכויות שמורות
          </p>
        </div>
      </div>
    </footer>
  );
}
